import React from 'react';
import MaterialTable from 'material-table'
import { useStyles, tableIcons } from '../../sharedComponents/Tablas/styles';

const TablePostVenta = (props) => {
  const {
    dataTable = [],
    onSelectRow,
    columns,
    title,
    pageSize = 10,
    isSelection = false,
    loading,
  } = props;
  const classes = useStyles();
  let data = [];

  if (dataTable) {
    data = dataTable;
    console.log(data)
  }

  return (
    <div className={classes.root}>
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          title={title}
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} of {count}',
            },
            toolbar: {
              nRowsSelected: '{0} row(s) selected',
            },
            header: {
              actions: null,
            },
            body: {
              emptyDataSourceMessage: ' No hay datos en la tabla',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
          //icons={tableIcons}
          isLoading={loading}
          columns={columns}
          data={data}
          options={{
            pageSize,
            loadingType: 'linear',
            actionsColumnIndex: -1,
            draggable: false,
            filtering: false,
            search: true,
            padding: 'dense',
            exportAllData: true,
            showTextRowsSelected: false,
            showSelectAllCheckbox: false,
            addRowPosition: 'first',
            exportFileName: 'Exportación Lucia Analitics',
            headerStyle: {
              backgroundColor: '#1B1B1B',
              color: '#FFF',
            },
            selection: isSelection,
            selectionProps: (rowData) => ({
              color: rowData?.tableData?.estado == 1 ? 'primary' : 'secondary',
            }),
          }}
          onSelectionChange={(rowData, selectedRow) => onSelectRow(selectedRow)}
        />
      </div>
    </div>
  );
};

export default TablePostVenta;
